module.exports = __webpack_public_path__ + "img/speed-4.abd3d5d6.png";